import { render, staticRenderFns } from "./PurposeForm.vue?vue&type=template&id=1d802054&"
import script from "./PurposeForm.vue?vue&type=script&lang=js&"
export * from "./PurposeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports